"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
const Provider_1 = __importDefault(require("./Provider"));
const Report_1 = __importDefault(require("./Report"));
class Oracle {
    constructor(data) {
        var _a;
        this.data = data;
        this._providers = [];
        for (const provider of (_a = this.data) === null || _a === void 0 ? void 0 : _a.providers) {
            this._providers.push(new Provider_1.default(provider));
        }
    }
    get address() {
        return this.data.id;
    }
    get delay() {
        return new bignumber_js_1.BigNumber(this.data.reportDelaySec);
    }
    get expiry() {
        return new bignumber_js_1.BigNumber(this.data.reportExpirationTimeSec);
    }
    get minimumProviders() {
        return new bignumber_js_1.BigNumber(this.data.minimumProviders).toNumber();
    }
    get scalar() {
        return new bignumber_js_1.BigNumber(this.data.scalar);
    }
    get providers() {
        return this._providers;
    }
    get activeProviders() {
        return this.providers.filter((p) => p.active);
    }
    getProvider(providerID) {
        const p = this.providers.filter((p) => p.address == providerID);
        return p.length > 0 ? p[0] : null;
    }
    getData() {
        const now = Math.trunc(Date.now() / 1000);
        const r = this.medianReportAt(now);
        return r == null ? new bignumber_js_1.BigNumber(0) : r.div(this.scalar);
    }
    medianReportAt(timestamp) {
        const delay = this.delay;
        const expiry = this.expiry;
        const _reports = this.providers.map((p) => {
            const activeReports = p.reports
                .filter((r) => r.isActiveAt(Math.trunc(timestamp), delay, expiry))
                .sort(Report_1.default.cmpTimestamp);
            // return the most recent (highest timestamp)
            return activeReports.length >= 1
                ? activeReports[activeReports.length - 1]
                : null;
        });
        return _reports && _reports.length >= this.minimumProviders
            ? Report_1.default.median(_reports)
            : null;
    }
}
exports.default = Oracle;
//# sourceMappingURL=Oracle.js.map